import React from "react";
import FlexView from "react-flexview";

const Modal = ({ handleClose, show, children, text, subText}) => {
  return (
    <div className={show ? "xmodal display-block" : "xmodal display-none"}>
      <section className="xmodal-main">
        <FlexView>
          <div className="grid grid-2x">
            <div className="col-1">
              <div className="txt-site c-n-title txt-18 txt-bold txt-main padding-top-5px margin-bottom-5px">
                  {text}
              </div>
              <div className="txt-site c-n-title txt-12 txt-main padding-top-5px margin-bottom-5px">
                  {subText}
              </div>
            </div>
            <div className="col-2 content-right">
              <button className="btn btn-circle btn-grey" onClick={handleClose}>
                <i className="fa fa-lg fa-times" />
              </button>
            </div>
          </div>
        </FlexView>
        {children}
      </section>
    </div>
  );
};

export default Modal;
